<template>
<div>
  <p class="has-text-weight-bold has-text-secondary">Headers</p>
  <div v-if="!Object.keys(route.response_headers).length">
    <p class="has-text-danger">No Headers Found.</p>
    <p class="help">Snitch is only able to gather header information from public routes.</p>
  </div>
  <div v-else>
    <table class="table is-fullwidth">
      <tbody>
        <tr v-for="(values, header) in route.response_headers" :key="header">
          <td>{{ header }}</td>
          <td>
            <span v-for="(headerValue, index) in values" :key="index">{{ headerValue }}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>  
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  
  computed: {
    ...mapGetters('route', [
      'route'
    ])
  }

}
</script>